/* Lashthing 2026-09-15: de stijlkiezer van Globo (product groups) boven de Kaching-bundel zetten.
 * Beide blokken worden client-side gerenderd; Globo landt standaard IN het koopformulier, dus onder
 * de bundelkiezer. Klanten kiezen logischer eerst hun stijl en dan het aantal.
 * Alleen de product-groups-dropdown wordt verplaatst, nooit de Globo-swatch-radio's (die horen in
 * het formulier). Ontbreekt een van beide blokken, dan doet dit script niets. */
(function () {
  'use strict';

  var bezig = false;

  function verplaats() {
    var info = document.querySelector('.product__info-container');
    var kiezer = document.querySelector('.globo-product-groups-detail');
    var bundel = document.querySelector('kaching-bundle');
    if (!info || !kiezer || !bundel) return;

    /* het blok dat direct onder .product__info-container hangt en de bundel bevat */
    var doel = bundel;
    while (doel && doel.parentElement !== info) doel = doel.parentElement;
    if (!doel) return;

    if (kiezer.parentElement === info && kiezer.nextElementSibling === doel) return; // staat al goed

    bezig = true;
    info.insertBefore(kiezer, doel);
    kiezer.classList.add('lt-style-verplaatst');
    bezig = false;
  }

  function plan() {
    if (bezig) return;
    window.requestAnimationFrame(verplaats);
  }

  function start() {
    verplaats();
    if (window.MutationObserver) {
      var root = document.querySelector('.product__info-container') || document.body;
      new window.MutationObserver(plan).observe(root, { childList: true, subtree: true });
    }
    /* apps renderen soms pas laat; een paar controles kosten niets */
    [400, 1200, 2500, 5000].forEach(function (ms) { window.setTimeout(verplaats, ms); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
